import { render, staticRenderFns } from "./DkColorSelectionDST.vue?vue&type=template&id=cab7fdc8&"
import script from "./DkColorSelectionDST.vue?vue&type=script&lang=js&"
export * from "./DkColorSelectionDST.vue?vue&type=script&lang=js&"
import style0 from "@v4/vdp/components/molecules/ColorSelection/_index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports